// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.InvoiceHistoryTable {
  width: calc(100% + 3rem);
  --sp-border-color: none;
}
.Table.InvoiceHistoryTable table .TableRow {
  --cell-count: 17;
  border-bottom: 1px solid rgba(197, 197, 197, 0.5);
}
.Table.InvoiceHistoryTable table .TableRow.TableRow-Header {
  background-color: var(--bs-secondary-subtle);
}
.Table.InvoiceHistoryTable table .TableRow.TableRow-Header .TableCell-Content {
  justify-content: center;
  display: flex;
  align-items: center;
}
.Table.InvoiceHistoryTable table .TableRow.amended {
  background-color: #e7f4ff;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.alternate {
  background-color: rgba(197, 197, 197, 0.2);
  line-height: 3rem;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell .TableCell-Content {
  align-content: center;
  text-align: center;
  white-space: wrap;
  font-weight: 700;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.SELECT {
  width: 2%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.DOWNLOAD {
  width: 3%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.SENT, .Table.InvoiceHistoryTable table .TableRow .TableCell.ACTIVITY {
  width: 3.25%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.ID {
  width: 5%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.ID.TableCell[data-status] .TableCell-Content::after {
  display: block;
  font-size: 0.75rem;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.ID.TableCell[data-status="most recent"] .TableCell-Content::after {
  color: var(--bs-success);
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.EXPAND {
  width: 1.25%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.EXPAND button {
  padding: 0;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.INVDATE, .Table.InvoiceHistoryTable table .TableRow .TableCell.START, .Table.InvoiceHistoryTable table .TableRow .TableCell.END, .Table.InvoiceHistoryTable table .TableRow .TableCell.AIRPORT, .Table.InvoiceHistoryTable table .TableRow .TableCell.DUE {
  width: 6.25%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.AMOUNT, .Table.InvoiceHistoryTable table .TableRow .TableCell.AMENDED, .Table.InvoiceHistoryTable table .TableRow .TableCell.CREATED {
  width: 7%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.CLIENT, .Table.InvoiceHistoryTable table .TableRow .TableCell.CREATOR, .Table.InvoiceHistoryTable table .TableRow .TableCell.SENTBY {
  width: 10%;
}
.Table.InvoiceHistoryTable table .TableRow .TableCell.DOWNLOAD .TableCell-Content, .Table.InvoiceHistoryTable table .TableRow .TableCell.SENT .TableCell-Content, .Table.InvoiceHistoryTable table .TableRow .TableCell.ACTIVITY .TableCell-Content {
  font-size: 1.5rem;
  color: var(--bs-primary);
}
.Table.InvoiceHistoryTable table .TableCollapse .TableRow {
  background-color: #f7fdff;
}`, "",{"version":3,"sources":["webpack://./src/pages/InvoiceHistory/InvoiceHistoryTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;EACA,uBAAA;AADF;AAGI;EACE,gBAAA;EACA,iDAAA;AADN;AAGM;EACE,4CAAA;AADR;AAEQ;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;AAAV;AAIM;EACE,yBAAA;AAFR;AAMQ;EACE,0CAAA;EACA,iBAAA;AAJV;AAOQ;EACE,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AALV;AAQQ;EACE,SAAA;AANV;AAQQ;EACE,SAAA;AANV;AAQQ;EAEE,YAAA;AAPV;AASQ;EACE,SAAA;AAPV;AASY;EACE,cAAA;EACA,kBAAA;AAPd;AAWY;EACE,wBAAA;AATd;AAaQ;EACE,YAAA;AAXV;AAYU;EACE,UAAA;AAVZ;AAaQ;EAKE,YAAA;AAfV;AAiBQ;EAGE,SAAA;AAjBV;AAmBQ;EAGE,UAAA;AAnBV;AAyBU;EACE,iBAAA;EACA,wBAAA;AAvBZ;AA6BM;EACE,yBAAA;AA3BR","sourcesContent":["@import '../../../globals.scss';\n\n.Table.InvoiceHistoryTable {\n  width: calc(100% + 3rem);\n  --sp-border-color: none;\n  table {\n    .TableRow {\n      --cell-count: 17;\n      border-bottom: 1px solid rgba(197, 197, 197, 0.5);\n\n      &.TableRow-Header {\n        background-color: var(--bs-secondary-subtle);\n        .TableCell-Content {\n          justify-content: center;\n          display: flex;\n          align-items: center;\n        }\n      }\n\n      &.amended {\n        background-color: #e7f4ff;\n      }\n\n      .TableCell {\n        &.alternate {\n          background-color: rgba(197, 197, 197, 0.2);\n          line-height: 3rem;\n        }\n\n        .TableCell-Content {\n          align-content: center;\n          text-align: center;\n          white-space: wrap;\n          font-weight: 700;\n        }\n\n        &.SELECT {\n          width: 2%;\n        }\n        &.DOWNLOAD {\n          width: 3%;\n        }\n        &.SENT,\n        &.ACTIVITY {\n          width: 3.25%;\n        }\n        &.ID {\n          width: 5%;\n          &.TableCell[data-status] {\n            .TableCell-Content::after {\n              display: block;\n              font-size: 0.75rem;\n            }\n          }\n          &.TableCell[data-status='most recent'] {\n            .TableCell-Content::after {\n              color: var(--bs-success);\n            }\n          }\n        }\n        &.EXPAND {\n          width: 1.25%;\n          button {\n            padding: 0;\n          }\n        }\n        &.INVDATE,\n        &.START,\n        &.END,\n        &.AIRPORT,\n        &.DUE {\n          width: 6.25%;\n        }\n        &.AMOUNT,\n        &.AMENDED,\n        &.CREATED {\n          width: 7%;\n        }\n        &.CLIENT,\n        &.CREATOR,\n        &.SENTBY {\n          width: 10%;\n        }\n\n        &.DOWNLOAD,\n        &.SENT,\n        &.ACTIVITY {\n          .TableCell-Content {\n            font-size: 1.5rem;\n            color: var(--bs-primary);\n          }\n        }\n      }\n    }\n    .TableCollapse {\n      .TableRow {\n        background-color: #f7fdff;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
